<label *ngIf="label" [for]="id" [ngClass]="colorLabel" class="__label" [innerHTML]="getLabel()"> </label>
<app-tooltip *ngIf="tooltip" [description]="tooltip"></app-tooltip>
